import {
  Component,
  ElementRef,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from "@angular/core";
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from "@angular/router";
import { MatDrawer, MatDrawerContainer } from "@angular/material/sidenav";
import { AgilGanttComponent } from "./agil-gantt/agil-gantt.component";
import { ParamComponent } from "./param/param.component";
import { LoadingService } from "./services/loading.service";
import { ApiService } from "./services/api.service";
import { QueryParameter } from "./helpers/queryParameter";
import { QueryFilter } from "./helpers/queryFilter";
import { UserContextService } from "./services/user-context.service";
import { Observable } from "rxjs";
import { UntypedFormControl, UntypedFormGroup, ReactiveFormsModule } from "@angular/forms";
import { generateFormGroupFromModelDefinition } from "./helpers/formgroup-generator";
import { map } from "rxjs/operators";
import { MatRadioButton, MatRadioChange, MatRadioGroup } from "@angular/material/radio";
import { MatDialog } from "@angular/material/dialog";
import { DialogComponent } from "./dialog/dialog.component";
import { MatInput } from "@angular/material/input";
import { MatFormField, MatLabel } from "@angular/material/form-field";
import { MatDivider } from "@angular/material/divider";
import { MatMenu, MatMenuItem } from "@angular/material/menu";
import { MatIcon } from "@angular/material/icon";
import { MatTooltip } from "@angular/material/tooltip";
import { MatMiniFabButton, MatIconButton, MatButton } from "@angular/material/button";
import { AsyncPipe } from "@angular/common";
import { MatToolbar, MatToolbarRow } from "@angular/material/toolbar";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.css"],
    standalone: true,
    imports: [
    MatToolbar,
    MatToolbarRow,
    MatMiniFabButton,
    MatTooltip,
    MatIcon,
    MatMenu,
    MatMenuItem,
    MatDivider,
    MatIconButton,
    MatButton,
    MatRadioGroup,
    MatRadioButton,
    RouterLink,
    RouterLinkActive,
    MatDrawerContainer,
    MatDrawer,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    RouterOutlet,
    AsyncPipe
],
})
export class AppComponent implements OnInit {
  @ViewChild(MatDrawer, { static: false }) sidenav: MatDrawer;
  @ViewChildren("showType") showGroup: QueryList<MatRadioButton>;
  private agilGanttComponent: AgilGanttComponent;
  componentReference: AgilGanttComponent | ParamComponent;
  title = "Planning de charges";
  spin: boolean;
  openCenters = false;
  openPostes = false;
  utilisateur$: Observable<any>;
  ganttModel$: Observable<any>;
  searchFormGroup: UntypedFormGroup;
  public userConnected$ = this.userContext.userConnectedSubject.asObservable();
  constructor(
    private router: Router,
    loadingService: LoadingService,
    private apiService: ApiService,
    private userContext: UserContextService,
    private dialog: MatDialog
  ) {
    loadingService.loading$.subscribe((service) => {
      if (service) {
        this.spin = true;
      } else {
        this.spin = false;
      }
    });
  }
  ngOnInit() {
    if (this.userContext.userConnected) {
      const queryParam = new QueryParameter();
      queryParam.querySelect = [];
      queryParam.querySelect.push("NonAccesEnrplan", "NonAccesExejalon");
      const filter = new QueryFilter();
      filter.Name = "Gestionnaire";
      filter.Value = this.userContext.userConnected;
      queryParam.queryFilters = [];
      queryParam.queryFilters.push(filter);
      this.utilisateur$ = this.apiService.generateHttpRequest(
        queryParam,
        "Utilisateur/getparams",
        null,
        "GET",
        null
      );
    }
    this.ganttModel$ = this.apiService.getGanttModel().pipe(
      map((model) => {
        this.searchFormGroup = generateFormGroupFromModelDefinition(
          model,
          undefined
        );
        this.searchFormGroup.reset();
        return model;
      })
    );
  }
  getControl(property): UntypedFormControl {
    return this.searchFormGroup.get(property.name) as UntypedFormControl;
  }
  goTo(where) {
    this.router.navigate([where]).then(() => {
      /** Obligé de tout recharger sinon le menu contextuel de marche plus */
      if (where === "gantt") {
        window.location.reload();
      }
    });
    this.sidenav.close();
  }
  refresh() {
    this.componentReference.refresh();
  }
  jalon() {
    this.agilGanttComponent.jalon();
  }
  loadGantt(search) {
    const queryParameter = new QueryParameter();
    queryParameter.queryFilters = [];

    for (const [key, value] of Object.entries(search)) {
      if (value) {
        const filter = new QueryFilter();
        filter.Name = key;
        filter.Value = value;
        queryParameter.queryFilters.push(filter);
      }
    }
    // console.log(queryParameter);
    this.agilGanttComponent.loadGantt(queryParameter);
  }
  export(type: "PDF" | "EXCEL" | "PNG") {
    this.agilGanttComponent.export(type);
  }
  closeOpenAll(taskType: number) {
    if (taskType === 1) {
      this.agilGanttComponent.closeOpenAll(taskType, this.openCenters);
      this.openCenters = !this.openCenters;
    } else if (taskType === 2) {
      this.agilGanttComponent.closeOpenAll(taskType, this.openPostes);
      this.openPostes = !this.openPostes;
    }
  }
  save() {
    this.componentReference.save();
  }
  onActivate(componentReference) {
    this.componentReference = componentReference;
    if (componentReference instanceof AgilGanttComponent) {
      this.agilGanttComponent = componentReference;
    }
  }
  activeVue() {
    return this.componentReference instanceof AgilGanttComponent
      ? "GANTT"
      : this.componentReference instanceof ParamComponent
      ? "PARAM"
      : "";
  }
  nbTasks() {
    return this.agilGanttComponent.nbOfs
      ? "(" + this.agilGanttComponent.nbOfs + " " + $localize`Ofs` + ")"
      : "(Aucun Of à afficher)";
  }
  zoomIn() {
    this.agilGanttComponent.zoom_in();
    this.showGroup.toArray().forEach((element) => {
      element.checked = false;
    });
  }
  zoomOut() {
    this.agilGanttComponent.zoom_out();
    this.showGroup.toArray().forEach((element) => {
      element.checked = false;
    });
  }
  viewTypechange(event: MatRadioChange) {
    if (event.value === "2") {
      this.agilGanttComponent.zoomToWeek();
    } else if (event.value === "1") {
      this.agilGanttComponent.zoomToFit();
    }
  }
  openLogs() {
    const dialogRef = this.dialog.open(DialogComponent, {
      width: "99%",
      height: "95%",
      data: {modelName: 'JalonLogs'},
    });

  }
}
